<template>
  <div id="contenedor-listado-licitacion-fallo-mobile">
    <template v-for="(participante, index) in licitacionParticipantes">
      <v-card :key="index" class="mb-3">
        <v-card-title>
          {{ participante.contratista.nombreRazonSocial }}
          <v-spacer></v-spacer>
          <v-btn
            v-if="!participante.fallo"
            icon
            @click="nuevoFalloParticipante(participante)"
          >
            <v-icon>mdi-folder-plus</v-icon>
          </v-btn>
          <v-btn
            v-else
            icon
            @click="editarFalloParticipante(participante)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-card-title>
      </v-card>
    </template>
  </div>
</template>

<script>
import LICITACION_PARTICIPANTES from '@/graphql/querys/administracion/licitaciones/participantes/licitacionParticipantes.gql';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ListadoLicitacionFalloMobile',
  data() {
    return {};
  },
  apollo: {
    licitacionParticipantes: {
      query: LICITACION_PARTICIPANTES,
      variables() {
        return {
          idLicitacion: this.$route.params.idLicitacion,
        };
      },
    },
  },
  methods: {
    nuevoFalloParticipante(participanteLicitacion) {
      eventBus.$emit('agregar-fallo-participante', participanteLicitacion);
    },
    editarFalloParticipante(participanteLicitacion) {
      eventBus.$emit('editar-fallo-participante', participanteLicitacion);
    },
  },
};
</script>

<style lang="scss">
</style>
